import React, { FC, useEffect, useState } from 'react'
import { Modal } from 'antd'
import { useBreakpoints } from '../../components'
import Form, { FormComponentProps } from 'antd/lib/form'
import { message, Button, Select } from 'antd'
import { User, UserFormValues, ServiceProvider, Reseller } from '../../types'
import { serviceProviderService } from '../../services'

interface UserFormProps extends FormComponentProps {
	user?: User
	submit(values: UserFormValues): Promise<void>
}

const UserForm: FC<UserFormProps> = props => {
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const [serviceProviders, setServiceProviders] = useState<ServiceProvider[]>([])
	const [resellers, setResellers] = useState<Reseller[]>([])

	const onSubmit = (): void => {
		setIsLoading(true)
		props.form.validateFields(
			async (errors, values): Promise<void> => {
				if (errors) {
					setIsLoading(false)
					message.error(errors)
					return
				}
				await props.submit(values)
				setIsLoading(false)
			}
		)
	}

	useEffect(() => {
		const getServiceProviders = async (): Promise<ServiceProvider[]> => {
			const { data } = await serviceProviderService.getAll()
			return data
		}
		getServiceProviders().then(setServiceProviders)
	}, [])

	const handleServiceProviderChange = async (serviceProviderId: number) => {
		const { data } = await serviceProviderService.getChildren(serviceProviderId)
		setResellers(data)
		props.form.resetFields()
	}

	return (
		<Form hideRequiredMark layout='horizontal' labelCol={{ span: 8 }} wrapperCol={{ span: 16 }} labelAlign='left'>
			<Form.Item label='Service Provider'>
				<Select
					showSearch
					filterOption={(input, option: React.ReactElement) => option.props.children.toLowerCase().includes(input.toLowerCase())}
					onChange={handleServiceProviderChange}
					placeholder={`Select a Service Provider`}
				>
					{serviceProviders?.map(({ id, name }) => (
						<Select.Option value={id} key={id}>
							{name}
						</Select.Option>
					))}
				</Select>
			</Form.Item>
			<Form.Item label='Reseller'>
				{props.form.getFieldDecorator('reseller_id', {
					rules: [
						{
							required: true,
							message: 'Reseller is required'
						}
					]
				})(
					<Select disabled={resellers.length === 0} placeholder='Select a Reseller' mode='default'>
						{resellers.map(sp => (
							<Select.Option value={sp.id} key={sp.id}>
								{sp.name}
							</Select.Option>
						))}
					</Select>
				)}
			</Form.Item>
			<div style={{ textAlign: 'right' }}>
				<Button type='primary' onClick={onSubmit}>
					{isLoading ? 'Saving' : 'Save'}
				</Button>
			</div>
		</Form>
	)
}
const WrappedUserForm = Form.create<UserFormProps>()(UserForm)

interface UserModalProps {
	isVisible: boolean
	close(): void
	user: User
	update(values: UserFormValues): Promise<void>
}

const EditResellerUserModal: FC<UserModalProps> = ({ user, update, isVisible, close }) => {
	const breakpoints = useBreakpoints()

	return (
		<>
			<Modal centered={breakpoints.md} destroyOnClose footer={null} visible={isVisible} onCancel={close} title={`Editing: ${user.name}`}>
				<WrappedUserForm user={user} submit={update} />
			</Modal>
		</>
	)
}

export default EditResellerUserModal
